const faqsConfig = {
  account: [
    {
      title: '如何注册帐号？',
      contents: [
        '由首页右上角【登录／注册】进入，点选【还没有帐号？注册】，输入完整个人信息及手机验证码，送出后即注册成功。（如果有信息不实，将会影响您参与的比赛的权益，请务必填写正确。）',
      ],
    },
    {
      title: '收不到认证短信，该怎么办？',
      contents: [
        '请确认您的手机号是否输入正确，若仍无法收到短信，请先按照下列方式排除问题：',
        '1. 更换浏览器，再进行发送验证',
        '2. 可能因过多的用户使用短信验证功能，造成线路忙碌，可稍后再试',
        '3. 检查手机收讯是否良好',
        '4. 拨打电话给电信业者确认手机是否有申请阻挡垃圾短信',
        '',
        '若进行以上操作仍无法排除问题，请与我们联系。',
        '电子邮箱：gdswqxh2018@163.com',
        '电话：020-81717361',
      ],
    },
    {
      title: '我的账号之前可以登录，今天突然登录不了了？',
      contents: [
        '您的帐号和密码必须与注册时完全相同。若注册时填写英文大写，请在登录时也输入大写，即可顺利登录。',
      ],
    },
    {
      title: '密码忘记了，该怎么办？',
      contents: [
        '由首页右上角【登录／注册】进入，点选【忘记密码】，填入注册时绑定的手机号收取验证码，输入验证码后即可重新设定密码。',
      ],
    },
    {
      title: '如何修改密码？',
      contents: [
        '点选右上角个人头像，选择【修改资料】－【更改密码】，依照指示填入信息后点选【保存变更】即修改完成。',
      ],
    },
    {
      title: '个人信息不小心填错了，可以修改吗？',
      contents: ['仅开放编辑姓名、机构、老师姓名，请于注册时填写正确信息。'],
    },
  ],
  tournament: [
    {
      title: '如何报名比赛？',
      contents: [
        '点选欲参加的比赛进入报名页面，确认您的姓名及手机号并选择参赛组别，缴费后即完成报名。',
      ],
    },
    {
      title: '报名比赛但还没缴费画面就跳掉了，要去哪里补缴费？',
      contents: [
        '您可以重新进入比赛的报名页面，再次确认您的姓名及手机号并选择参赛组别，缴费后即完成报名。',
      ],
    },
    {
      title: '为什么无法报名比赛？',
      contents: [
        '无法报名比赛的情形如下：',
        '',
        '1. 您的资格与您所选取的组别不符，请更换组别再试一次',
        '2. 比赛或是当组报名人数已达上限',
        '3. 已过报名截止时间',
      ],
    },
    {
      title: '一定要是会员才能报名比赛吗？',
      contents: ['是的，本系统所有项目皆须登录使用。'],
    },
    {
      title: '重复报名同个比赛了，该怎么办？',
      contents: [
        '如有重复报名情形发生，请尽速联系承办单位。',
        '（您可以在该比赛信息页面查看承办单位及联络信息。）',
      ],
    },
    {
      title: '我想取消报名，可以吗？',
      contents: [
        '各比赛由承办单位管理，如需取消报名请联系承办单位。',
        '（您可以在该比赛信息页面查看承办单位及联络信息。）',
      ],
    },
    {
      title: '如何查看成绩？',
      contents: [
        '比赛成绩发布后，您可以在比赛页面或是【个人信息】－【比赛】查看成绩。',
      ],
    },
    {
      title: '我要在哪里查看我的证书？',
      contents: ['比赛成绩发布后，您可以在【个人信息】－【证书】查看证书。'],
    },
    {
      title: '如何申请比赛实体证书？',
      contents: [
        '由【个人信息】－【证书】可查询您的证书，依照指示填入信息并缴费即完成申请。',
      ],
    },
  ],
  ai: [
    {
      title: 'AI 测评要如何购买？',
      contents: ['选择欲检定的棋力后缴费即完成报名。'],
    },
    {
      title: '为什么要在期限内完成所有关卡？',
      contents: [
        '为确保检定品质，需要在开始检定24小时内完成所有关卡。',
        '（若您未在期限内完成，将视同放弃本次检定，将不会有成绩单。）',
      ],
    },
    {
      title: '参赛许可证有什么用途？',
      contents: [
        '通过指定棋力的检定可获得参赛许可证，可用于报名本系统比赛。',
        '举例：张三的棋力为25级，参加20级AI 测评通过，获得20级的参赛许可证，则张三可报名适合棋力25级、20级的所有比赛。',
      ],
    },
    {
      title: '测验到一半断线，该怎么办？',
      contents: [
        '在检定时限结束前可随时离开，只需回到【AI 测评】便可继续作答。',
        '',
        '若您仍无法测验，请与我们联系。',
        '电子邮箱：gdswqxh2018@163.com',
        '电话：020-81717361',
      ],
    },
    {
      title: '觉得自己表现不好，可以重新做题吗？',
      contents: [
        '为确保测评分析品质，不得重新答题。',
        '各题没有作答时间限制，建议在答题前多多思考喔。',
      ],
    },
    {
      title: '为什么我按浏览器的「上一页」「下一页」，无法回到原来的页面呢？',
      contents: ['建议使用系统上提供的功能按钮。'],
    },
    {
      title: '在哪里可看到我所有的AI 测评纪录？',
      contents: ['您可以在【个人信息】－【测评】查看纪录。'],
    },
    {
      title: '一定要是会员才能测验吗？',
      contents: ['是的，本系统所有项目皆须登录使用。'],
    },
  ],
};
export default faqsConfig;
